import { AggregationsState } from '@features/aggregations/store/states/aggregations.state'
import { Action, createReducer, on } from '@ngrx/store'
import {
  initializeAggregationsSuccess,
  purgeAggregations,
  setAggregation,
  setAggregationIsMatchFlag,
  setAggregationIsVsEnabledFlag,
  setAggregationModes,
  setAggregations,
  setAggregationsDemarcation
} from '@features/aggregations/store/actions/aggregations.actions'

const initialState: AggregationsState = {
  isMatch: undefined,
  isVsEnabled: undefined,
  demarcation: undefined,
  aggregationModes: undefined,
  leftAggregation: undefined,
  rightAggregation: undefined,
  context: undefined,
  aggregation: undefined
}

const reducer = createReducer(
  initialState,
  on(initializeAggregationsSuccess, (state, { newState }) => ({ ...state, ...newState })),
  on(setAggregationIsVsEnabledFlag, (state, { isVsEnabled }) => ({ ...state, isVsEnabled })),
  on(setAggregationIsMatchFlag, (state, { isMatch }) => ({ ...state, isMatch })),
  on(setAggregationsDemarcation, (state, { demarcation }) => ({ ...state, demarcation })),
  on(setAggregations, (state, { leftAggregation, rightAggregation }) => ({
    ...state,
    leftAggregation,
    rightAggregation
  })),
  on(setAggregation, (state, { aggregation }) => ({ ...state, aggregation })),
  on(setAggregationModes, (state, { aggregationModes }) => ({ ...state, aggregationModes })),
  on(purgeAggregations, () => ({ ...initialState }))
)

export const aggregationsReducer = (state: AggregationsState | undefined, action: Action): AggregationsState =>
  reducer(state, action)
